import getJson from "./api/getJson";
import createPromise from "./createPromise";
import getStaticFileUrl from "./getStaticFileUrl";
import { coreLogger } from "./logger";
import { ITCFGlobalVendorList as ITCFGlobalVendorListResponse } from "types/tcf";
import { cachedGVL } from "hooks/useLoadTCFGlobalVendorList";

const fetchTCFGlobalVendorList = (
  version: string | null,
  lang: string
): Promise<ITCFGlobalVendorListResponse> => {
  const url = getStaticFileUrl(`/tcf/${lang}.json`, version);
  return createPromise<ITCFGlobalVendorListResponse>((resolve, reject) => {
    if (cachedGVL[lang]) {
      coreLogger(`Load cached global vendor list: ${lang} `);
      return resolve(cachedGVL[lang]);
    }

    coreLogger("Load global vendor list file from " + url);
    getJson(url).then(
      ([res]) => {
        coreLogger("Global Vendor List loaded");

        cachedGVL[lang] = res as ITCFGlobalVendorListResponse;

        resolve(cachedGVL[lang]);
      },
      (e) => {
        coreLogger(new Error("Failed to load Global Vendor List"));
        reject(e);
      }
    );
  });
};

export default fetchTCFGlobalVendorList;
